import { Component } from '@angular/core';

@Component({
  selector: 'app-ingress-details',
  templateUrl: './ingress-details.component.html',
  styleUrls: ['./ingress-details.component.scss']
})
export class IngressDetailsComponent {

}
